import { RouteProps } from '../../../types';
import { Login } from '../pages';

import { AuthRoutePath } from './path';

export const routes: RouteProps[] = [
  {
    path: '/',
    Component: Login,
    exact: true,
    type: 'Public',
  },
  {
    path: `/${AuthRoutePath.Login}`,
    Component: Login,
    exact: true,
    type: 'Public',
  },
];
